import { asyncComponent } from 'react-async-component';

const AppMain = asyncComponent({
  resolve: () => System.import('./appmain')
});

const ContactList = asyncComponent({
  resolve: () => System.import('./contactlist')
});

const ContactDetails = asyncComponent({
  resolve: () => System.import('./contactdetails')
});


const Login = asyncComponent({
  resolve: () => System.import('./login')
});

const Main = asyncComponent({
  resolve: () => System.import('./main')
});

const Phone = asyncComponent({
  resolve: () => System.import('./phone')
});

const Update = asyncComponent({
  resolve: () => System.import('./update')
});

const SettingsNavPage = asyncComponent({
  resolve: () => System.import('./settingsnav')
});

const SettingsCategory = asyncComponent({
  resolve: () => System.import('./settingscategory')
});

export { AppMain, ContactList, ContactDetails, Login, Main, Phone, Update, SettingsNavPage, SettingsCategory };



// WEBPACK FOOTER //
// ./src/routes/index.js